import { Icon, IconButton } from '@atom/mui';
import { CheckCircleIcon, CheckCircleOutlineIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';

export type TaskCompletionIconProps = { isCompleted: boolean };

const TaskCompletionIcon = ({ isCompleted }: TaskCompletionIconProps) => (
  <IconButton>
    <Icon
      color={isCompleted ? colors.brand.green : colors.neutral.silver}
      icon={isCompleted ? CheckCircleIcon : CheckCircleOutlineIcon}
    />
  </IconButton>
);

export default TaskCompletionIcon;
